module.exports = __webpack_public_path__ + "images/emoji/radio.a62fde4033938ce39dc4.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/radio.png
// module id = KUWp
// module chunks = 13